/**
 * 视频服务层共享：API 基础地址 + authFetch + 响应解包
 *
 * 底层已统一委托 platform/http：API_BASE 判定、鉴权头、401 清会话与广播
 * 均由平台层维护，本文件仅保留视频模块消费方的 import 兼容签名。
 */

import { API_BASE, platformFetch, readEnvelope, PlatformApiError } from '../../../platform/http';

export { API_BASE };

/**
 * 带鉴权头的 fetch 封装
 * 401 时平台层自动清空当前会话并广播
 */
export async function authFetch(path: string, options: RequestInit = {}): Promise<Response> {
  return platformFetch(path, options);
}

/**
 * 解析后端统一响应格式 `{ ok, data }`，失败时抛 PlatformApiError
 *
 * 兼容裸数据格式（响应体没有 ok 字段时直接返回）
 */
export async function readData<T>(response: Response, fallback: string): Promise<T> {
  const data = await readEnvelope<T>(response, fallback);
  // 保留视频模块历史行为：2xx 但响应体为空（JSON 解析失败）同样视为失败
  if (data === null || data === undefined) throw new PlatformApiError(fallback, response.status);
  return data;
}

export { PlatformApiError };
